module.exports = __webpack_public_path__ + "img/pos_s2_icon5.d6ca2b84.png";